import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import Event from '../../actions/event';
import Api from '../../../api';
import {FetchDashboardDataPayload} from '../../actions/dashboardCommand';

function* onFetchDashboardData(data: FetchDashboardDataPayload): Generator {
    try {
        const dashboardData: any = yield call(Api.Query.dashboardData, data.month);
        yield put(Event.Dashboard.dashboardDataFetched({ data: dashboardData }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Dashboard-Daten konnten nicht geladen werden.',
        }));
    }
}

export function* fetchDashboardDataFlow() {
    while (true) {
        const action: Action<FetchDashboardDataPayload> =
            yield take(Command.Dashboard.fetchDashboardData.toString());
        yield fork(onFetchDashboardData, action.payload);
    }
}
